export const getTimeFromMiliseconds = (value) => {
  const totalSeconds = Math.floor(value / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (totalSeconds % 60).toString().padStart(2, "0");

  return hours > 0 ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
};

export const getTimeAsMinutesSeconds = (value) => {
  const totalSeconds = Math.floor(value / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (minutes > 0) {
    return `${minutes}' ${seconds}''`;
  } else {
    return `${seconds}''`;
  }
};

export const formatTimer = (value) => {
  switch (value) {
    case 0:
      return "00";
      break;
    case 1:
      return "01";
      break;
    case 2:
      return "02";
      break;
    case 3:
      return "03";
      break;
    case 4:
      return "04";
      break;
    case 5:
      return "05";
      break;
    case 6:
      return "06";
      break;
    case 7:
      return "07";
      break;
    case 8:
      return "08";
      break;
    case 9:
      return "09";
      break;
    default:
      return value.toString();
      break;
  }
};

export const completeTimerFormat = (date) => {
  if (!date) return "00:00:00";
  let mm = date.getUTCMinutes();
  let ss = date.getSeconds();
  let cm = Math.round(date.getMilliseconds() / 10);

  mm = mm < 10 ? "0" + mm : mm;
  ss = ss < 10 ? "0" + ss : ss;
  cm = cm < 10 ? "0" + cm : cm;

  return `${mm}:${ss}:${cm}`;
};

export const TimerFormatResta = (dateA, dateB) => {
  if (!dateA || !dateB) return "00:00:00";
  const dateTotal = dateA - dateB;
  const dateFinal = new Date(dateTotal);

  let mm = dateFinal.getUTCMinutes();
  let ss = dateFinal.getSeconds();

  mm = mm < 10 ? "0" + mm : mm;
  ss = ss < 10 ? "0" + ss : ss;

  return `00:${mm}:${ss}`;
};

export const timerFormat = (date) => {
  if (!date) return "00:00";
  let mm = date.getUTCMinutes();
  let ss = date.getSeconds();

  mm = mm < 10 ? "0" + mm : mm;
  ss = ss < 10 ? "0" + ss : ss;

  return `${mm}:${ss}`;
};
export const millisecondsFormat = (date) => {
  if (!date) return "00";
  let cm = Math.round(date.getMilliseconds() / 10);
  cm = cm < 10 ? "0" + cm : cm;
  return `${cm}`;
};
export const secondsFormat = (date) => {
  if (!date) return "00";
  let ss = date.getSeconds();
  ss = ss < 10 ? "0" + ss : ss;
  return `${ss}`;
};
export const minutesFormat = (date) => {
  if (!date) return "00";
  let mm = date.getUTCMinutes();
  mm = mm < 10 ? "0" + mm : mm;
  return `${mm}`;
};

export const counterFormat = (value) => {
  if (!value) return "00";
  const temporal = parseInt(value) < 10 ? "0" + value : value;
  return `${temporal}`;
};

import {
  OptionsEvaluaRitmo,
  OptionsRitmoECG,
  TimelineDefault,
} from "./Constants";
export const resetTimeline = (ctxTimeline) => {
  const keys = Object.keys(ctxTimeline);
  keys.map((key) => {
    ctxTimeline[key] = TimelineDefault[key];
  });
};

export const abreviatePcrText = (text) => {
  // Mapeo directo de nombres completos a acrónimos
  const acronymMapping = {
    // Ritmos cardíacos
    "Actividad eléctrica sin pulso": "AESP",
    "Fibrilación ventricular": "FV",
    "Taquicardia ventricular sin pulso": "TVSP",
    "Taquicardia ventricular con pulso": "TVCP",
    "Taquicardia supraventricular": "TSV",
    "Ritmo sinusal": "Sinusal",
    
    // Bloqueos cardíacos
    "Bloqueo de 1er grado": "Bloq. 1º",
    "Bloqueo 2º grado Mobitz I": "Bloq. 2º I",
    "Bloqueo 2º grado Mobitz II": "Bloq. 2º II",
    "Bloqueo 3er grado": "Bloq. 3º",
    
    // Procedimientos
    "Parada cardiorrespiratoria": "PCR",
    "Reanimación cardiopulmonar": "RCP",
    "Recuperación de la circulación espontánea": "RCE",
    "Intubación endotraqueal": "IOT",
    "Intubación orotraqueal/Dispositivo supraglótico": "IOT/DSG",
    "Dispositivo supraglótico": "DSG",
    "Desfibrilador semiautomático": "DEA",
    "Electrocardiograma": "ECG",
    "Obstrucción de la vía aérea por cuerpo extraño": "OVACE",
    
    // Versiones en inglés
    "Pulseless electrical activity": "AESP",
    "Ventricular fibrillation": "FV",
    "Pulseless ventricular tachycardia": "TVSP",
    "Ventricular tachycardia with pulse": "TVCP",
    "Supraventricular tachycardia": "TSV",
    "Sinus rhythm": "Sinusal",
    "1st Degree block": "Bloq. 1º",
    "Mobitz I 2nd degree block": "Bloq. 2º I",
    "Mobitz II 2nd degree block": "Bloq. 2º II",
    "3rd Degree block": "Bloq. 3º",
    "Cardiorespiratory arrest": "PCR",
    "Cardiopulmonary resuscitation": "RCP",
    "Return of spontaneous circulation": "RCE",
    "Endotracheal intubation": "IOT",
    "Orotracheal intubation/Supraglottic airway device": "IOT/DSG",
    "Supraglottic airway device": "DSG",
    "Automated external defibrillator": "DEA",
    "Electrocardiogram": "ECG",
    "Foreign-body airway obstruction": "OVACE",
    
    // Versiones en italiano
    "Attività elettrica senza polso": "AESP",
    "Fibrillazione ventricolare": "FV",
    "Tachicardia ventricolare senza polso": "TVSP",
    "Tachicardia ventricolare con pulsazioni": "TVCP",
    "Tachicardia sopraventricolare": "TSV",
    "Ritmo sinusale": "Sinusal",
    "Blocco di 1° grado": "Bloq. 1º",
    "Blocco di 2° grado Mobitz I": "Bloq. 2º I",
    "Blocco di 2° grado Mobitz II": "Bloq. 2º II",
    "Blocco di 3° grado": "Bloq. 3º",
    "Arresto cardiorespiratorio": "PCR",
    "Rianimazione cardiopolmonare": "RCP",
    "Ritorno alla circolazione spontanea": "RCE",
    "Intubazione endotracheale": "IOT",
    "Intubazione endotracheale/Dispositivo sovraglottico": "IOT/DSG",
    "Dispositivo sopraglottico": "DSG",
    "Defibrillatore semiautomatico": "DEA",
    "Elettrocardiogramma": "ECG",
    "Ostruzione delle Vie Aeree da Corpo Estraneo": "OVACE",
    
    // Versiones en portugués
    "Atividade elétrica sem pulso": "AESP",
    "Fibrilação ventricular": "FV",
    "Taquicardia ventricular sem pulso": "TVSP",
    "Taquicardia ventricular com pulso": "TVCP",
    "Taquicardia supraventricular": "TSV",
    "Ritmo sinusal": "Sinusal",
    "Bloqueio de 1º grau": "Bloq. 1º",
    "Bloqueio de 2º grau Mobitz I": "Bloq. 2º I",
    "Bloqueio de 2º grau Mobitz II": "Bloq. 2º II",
    "Bloqueio de 3º grau": "Bloq. 3º",
    "Paragem cardiorrespiratória": "PCR",
    "Reanimação cardiopulmonar": "RCP",
    "Recuperação da circulação espontânea": "RCE",
    "Entubação endotraqueal": "IOT",
    "Intubação endotraqueal/Dispositivo supraglótico": "IOT/DSG",
    "Dispositivo supraglótico": "DSG",
    "Desfibrilhador semiautomático": "DEA",
    "Eletrocardiograma": "ECG",
    "Obstrução das vias aéreas por corpos estranhos": "OVACE",
  };

  // Buscar en el mapeo directo
  if (acronymMapping[text]) {
    return acronymMapping[text];
  }

  // Fallback al sistema anterior para compatibilidad
  const AbrevitedRitmoECG = [
    "AS",
    "AESP",
    "FV",
    "TVSP",
    "Bloq. 1º",
    "TVCP",
    "Bloq. 2º I",
    "TP",
    "Bloq. 2º II",
    "TSV",
    "Bloq. 3º",
    "Sinusal",
  ];

  const AbrevitedEvaluaRitmo = ["Asis", "AESP", "FV", "TV SP", "Otro"];

  const finder1 = OptionsRitmoECG.map((item, index) => ({
    item,
    index,
  })).filter((i) => i.item == text);
  if (finder1.length > 0) {
    const texto = finder1[0].index;
    return AbrevitedRitmoECG[texto];
  }

  const finder2 = OptionsEvaluaRitmo.map((item, index) => ({
    item,
    index,
  })).filter((i) => i.item == text);
  if (finder2.length > 0) {
    const texto = finder2[0].index;
    return AbrevitedEvaluaRitmo[texto];
  }
  
  console.log("no se encontro este:" + text, finder1, finder2);
  return text;
};

export function formatMs(ms) {
  // Convierte milisegundos a mm:ss
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `0${minutes + ":"}${seconds < 10 ? "0" : ""}${seconds}`;
}
